<template>
  <div class="stores-page">
    <!-- Hero Section -->
    <section class="hero">
      <!-- <div class="hero-content">
        <h1 class="hero-title"></h1>
        <p class="hero-description"></p>
      </div> -->
      <img class="hero-image" src="https://www-img.sanfu.com/production/shop_top.png" alt="" />
      <!-- <img class="hero-image" src="~/assets/image/shop_top.png" alt="" /> -->
    </section>

    <!-- Store Stats -->

    <!-- Store Gallery -->
    <section class="store-gallery">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">
            {{ locale === 'zh' ? '全新品牌形象' : locale === 'en' ? 'New Brand Image' : 'Galeri Toko' }}
          </h2>
          <p class="section-description">
            {{ locale === 'zh' ? '开创生活方式旗舰店 悦享潮流生活市集' : locale === 'en' ? 'Creating lifestyle flagship stores, enjoying trendy life markets' : 'Jelajahi jaringan toko global kami dan rasakan merek unik kami' }}
          </p>
        </div>

        <div class="stores-grid">
          <div v-for="store in stores" :key="store.id" class="store-card" @click="openGallery(store)">
            <div class="image-wrap">
              <el-image fit="cover" :src="store.img" class="image-placeholder" alt="" />
            </div>
            <div class="store-content">
              <h3 class="store-name">{{ store.name }}</h3>
            </div>
          </div>
        </div>

        <!-- 图片画廊组件 -->
        <ImageGallery v-model="galleryVisible" :images="galleryImages" :title="galleryTitle" @close="galleryVisible = false" />
      </div>
    </section>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'

  useHead({
    title: '门店风采 - SANFU',
    meta: [{ name: 'description', content: '探索我们遍布全球的门店网络，体验独特的品牌文化' }]
  })

  const { locale } = useI18n()

  // 轮播图数据（初始为空，将通过API获取）
  const stores = ref([])

  // 使用 useAsyncData 获取banner数据，支持SSR，避免水合错误
  const { data: res } = await useAsyncData(
    'storesData',
    () =>
      $fetch('/api/banner/getList', {
        method: 'GET',
        params: {
          type: 3,
          pageSize: 10,
          locale: locale.value
        }
      }),
    { watch: [locale] }
  )
  const data = res.value?.data
  // 如果获取数据成功，更新轮播图数据
  if (data && Array.isArray(data) && data.length) {
    stores.value = data
  }

  // 画廊相关状态
  const galleryVisible = ref(false)
  const galleryImages = ref([])
  const galleryTitle = ref('')

  // 打开画廊
  const openGallery = store => {
    // 组合图片数组：主图 + imgList
    const images = [store.img]
    if (store.imgList && Array.isArray(store.imgList)) {
      images.push(...store.imgList)
    }

    galleryImages.value = images
    galleryTitle.value = store.name[locale.value]
    galleryVisible.value = true
  }
</script>

<style scoped lang="less">
  .hero {
    padding: var(--space-12) 0 0;
    background: linear-gradient(0deg, var(--gray-100) 0%, var(--white) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hero-content {
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: 3%;
    text-align: center;
  }

  .hero-title {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: var(--space-6);
    color: var(--gray-900);
  }

  .hero-description {
    font-size: var(--text-xl);
    color: var(--gray-600);
    line-height: 1.6;
  }

  .hero-image {
    width: 100%;
    max-height: 230px;
    object-fit: contain;
  }

  .store-gallery {
    padding: var(--space-12) 0;
  }

  .section-header {
    text-align: center;
    margin-bottom: var(--space-12);
  }

  .section-title {
    font-size: var(--text-3xl);
    font-weight: 600;
    margin-bottom: var(--space-4);
    color: var(--gray-900);
  }

  .section-description {
    font-size: var(--text-lg);
    color: var(--gray-600);
    max-width: 600px;
    margin: 0 auto;
  }

  .gallery-filter {
    display: flex;
    justify-content: center;
    gap: var(--space-4);
    margin-bottom: var(--space-12);
    flex-wrap: wrap;
  }

  .filter-btn {
    padding: var(--space-3) var(--space-6);
    border: 2px solid var(--gray-300);
    background-color: var(--white);
    color: var(--gray-600);
    border-radius: var(--radius-full);
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
  }

  .filter-btn:hover {
    border-color: var(--primary);
    color: var(--primary);
  }

  .filter-btn.active {
    background-color: var(--primary);
    border-color: var(--primary);
    color: var(--white);
  }

  .stores-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
    gap: var(--space-6);
    justify-content: center;
  }

  .store-card {
    background-color: var(--white);
    border-radius: var(--radius-xl);
    overflow: hidden;
    box-shadow: var(--shadow);
    transition: all var(--transition-base);
  }

  .store-card:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-lg);
    cursor: pointer;
  }

  .image-wrap {
    position: relative;
    padding-top: 56.25%;
    width: 100%;
  }

  .image-placeholder {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .store-icon {
    font-size: var(--text-6xl);
  }

  .store-badge {
    position: absolute;
    top: var(--space-4);
    right: var(--space-4);
    background-color: rgba(255, 255, 255, 0.9);
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius);
    font-size: var(--text-sm);
    font-weight: 500;
  }

  .store-content {
    padding: var(--space-6);
  }

  .store-name {
    text-align: center;
    font-size: var(--text-xl);
    font-weight: 600;
    margin-bottom: var(--space-2);
    color: var(--gray-900);
  }

  .store-location {
    color: var(--gray-500);
    margin-bottom: var(--space-3);
  }

  .store-description {
    color: var(--gray-600);
    line-height: 1.6;
    margin-bottom: var(--space-4);
  }

  .store-features {
    display: flex;
    gap: var(--space-2);
    margin-bottom: var(--space-4);
    flex-wrap: wrap;
  }

  .feature-tag {
    padding: var(--space-1) var(--space-3);
    background-color: var(--gray-100);
    color: var(--gray-700);
    border-radius: var(--radius-full);
    font-size: var(--text-sm);
  }

  .store-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--gray-100);
    padding-top: var(--space-4);
  }

  .store-hours {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    font-size: var(--text-sm);
    color: var(--gray-500);
  }

  .store-hours svg {
    width: 16px;
    height: 16px;
  }

  .visit-btn {
    padding: var(--space-2) var(--space-4);
    background-color: var(--primary);
    color: var(--white);
    border: none;
    border-radius: var(--radius);
    font-weight: 500;
    cursor: pointer;
    transition: background-color var(--transition-fast);
  }

  .visit-btn:hover {
    background-color: var(--primary-dark);
  }

  @media (max-width: 768px) {
    .hero-title {
      font-size: var(--text-3xl);
    }
    .hero-description {
      font-size: 16px;
    }
    .stores-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
